import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'app/store/store';
import { useGetTheme } from 'hooks/useGetTheme';
import styles from './Header.module.scss';

export const Logo = () => {
  const { t } = useTranslation();

  const defaultStyleUI = useAppSelector((state) => state.userSlice.uiConfig?.feDefaultStyleUI);

  const theme = useGetTheme(defaultStyleUI?.toLowerCase());

  const getTitle = (theme: string) => {
    switch (theme) {
      case 'base':
        return 'AISX';
      case 'egis':
        return t('EgisPageTitle');
      case 'lukoil':
        return `${t('LukoilPageTitle')}`;
      default:
        return null;
    }
  };
  const title = getTitle(theme);

  return (
    <div className={styles.logo}>
      <div className={styles[theme]} />
      {title && <div className={styles.logo_title}>{title}</div>}
    </div>
  );
};
